import { apiRequest } from "@/lib/api/client";
import type { EnvelopeCatalogResponse } from "@/lib/api/types";

export async function getEnvelopeCatalog(): Promise<EnvelopeCatalogResponse> {
  return apiRequest<EnvelopeCatalogResponse>("/envelope/catalog");
}
